import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Card, Button, Space, Typography, Flex, Image } from "antd";
import { PlayCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import "./GameList.css";

const { Title, Text, Paragraph } = Typography;

interface Game {
  id: string;
  name: string;
  logo: string;
  description: string;
  category: string;
  released: boolean;
  link?: string;
}

interface GameSection {
  title: string;
  games: Game[];
}

const GameList: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Mock data - replace with actual API data
  const gameSections: GameSection[] = [
    {
      title: t("gameList.popularGames"),
      games: [
        // {
        //   id: "1",
        //   name: t("gameList.game1Name"),
        //   logo: "/games/vu-tru-than-thoai.png",
        //   description: t("gameList.game1Description"),
        //   category: "MMORPG",
        //   released: true,
        // },
        // {
        //   id: "2",
        //   name: t("gameList.game2Name"),
        //   logo: "/games/tang-long-bat-bai.png",
        //   description: t("gameList.game2Description"),
        //   category: "MMORPG",
        //   released: false,
        //   link: "https://facebook.com/vtcm.atplay",
        // },
        // {
        //   id: "3",
        //   name: t("gameList.game3Name"),
        //   logo: "/games/van-tien-chien.jpg",
        //   description: t("gameList.game3Description"),
        //   category: "MMORPG",
        //   released: false,
        //   link: "https://facebook.com/tlbbm.atplay",
        // },
      ],
    },
    // {
    //   title: t('gameList.comingSoon'),
    //   games: [
    //     // {
    //     //   id: '5',
    //     //   name: t('gameList.game5Name'),
    //     //   logo: '/games/phong-than-bang.jpg',
    //     //   description: t('gameList.game1Description'),
    //     //   category: 'MMORPG',
    //     //   released: false,
    //     // },
    //     {
    //       id: '6',
    //       name: t('gameList.updating'),
    //       logo: '/games/update.png',
    //       description: t('gameList.updating'),
    //       category: t('gameList.updating'),
    //       released: false,
    //     }
    //   ]
    // },
  ];

  // Demo: navigate straight to the payment page (no auth required).
  const handleDepositClick = (gameId: string) => {
    navigate(`/deposit/${gameId}`);
  };

  const renderGameCard = (game: Game) => (
    <Col xs={24} sm={12} md={8} lg={6} xl={6} key={game.id}>
      <Card
        className="game-card"
        hoverable
        cover={
          <div className="game-logo-container">
            <Image
              alt={game.name}
              src={game.logo}
              className="game-logo"
              preview={false}
              style={{ width: "100%", height: "100%" }}
            />
          </div>
        }
        actions={[
          game.released ? (
            <Button
              type="primary"
              icon={<PlayCircleOutlined />}
              onClick={() => handleDepositClick(game.id)}
              className="deposit-btn"
            >
              {t("gameList.depositNow")}
            </Button>
          ) : game.link ? (
            <Button
              type="primary"
              icon={<PlayCircleOutlined />}
              href={game.link}
              target="_blank"
              rel="noopener noreferrer"
              className="deposit-btn"
            >
              {t("gameList.joinNow")}
            </Button>
          ) : (
            <Button
              type="primary"
              icon={<PlayCircleOutlined />}
              className="deposit-btn"
              disabled
            >
              {t("gameList.comingSoonButton")}
            </Button>
          ),
        ]}
      >
        <Card.Meta
          title={game.name}
          description={
            <Space
              direction="vertical"
              size="small"
              className="game-meta-description"
            >
              <Paragraph className="game-description">
                {game.description}
              </Paragraph>
              <Text className="game-category">{game.category}</Text>
            </Space>
          }
        />
      </Card>
    </Col>
  );

  return (
    <Space direction="vertical" size="large" className="game-list-container">
        {gameSections.map((section, sectionIndex) => (
          <Space
            key={sectionIndex}
            direction="vertical"
            size="middle"
            className="game-section"
          >
            <Flex className="section-header" justify="center">
              <Title level={2} className="section-title">
                {section.title}
              </Title>
            </Flex>
            <Row gutter={[24, 24]} className="games-grid">
              {section.games.map(renderGameCard)}
            </Row>
          </Space>
        ))}
    </Space>
  );
};

export default GameList;
